import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: { main: '#16f288' },
    secondary: { main: '#353a4d' },
    background: { default: '#191c29', paper: '#23263a' },
    text: { primary: '#e0e0e0' }
  },
  typography: {
    fontFamily: '"Roboto", "Orbitron", Arial, sans-serif'
  }
});
